import { Header } from "../../components/cashierLandingComp/Header";
import { HeroSection } from "../../components/cashierLandingComp/HeroSection";
import { FeaturesSection } from "../../components/cashierLandingComp/FeaturesSection";
import { TestimonialsSection } from "../../components/cashierLandingComp/TestimonialsSection";
import { OffersSection } from "../../components/cashierLandingComp/OffersSection";
import { HowItWorksSection } from "../../components/cashierLandingComp/HowItWorksSection";
import { FinalCTASection } from "../../components/cashierLandingComp/FinalCTASection";
import { Image } from "antd";
import { useTranslation } from "react-i18next";
import { Mail, PhoneCall } from "lucide-react";
import { Helmet } from "react-helmet";

const CashierLandingPage = () => {
  const { i18n, t } = useTranslation();
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>
          myGINNE Cashier POS – Smart Retail System for Egyptian Stores
        </title>
        <meta
          name="description"
          content="Simplify your retail operations with myGINNE, Egypt’s smartest cashier & POS system. Works offline, supports Arabic, and sets up in 10 minutes. Free trial!"
        />
        <meta
          name="keywords"
          content="POS system Egypt, cashier app Egypt, myGINNE POS, retail billing software Egypt, Arabic POS system, store management app, weighing machine POS, barcode billing Egypt, free POS Egypt, grocery store software Egypt"
        />
        <link
          rel="canonical"
          href="https://store.myginne.com/cashier-pos-egypt"
        />

        <meta
          property="og:title"
          content="myGINNE Cashier POS – Smart Retail System for Egyptian Stores"
        />
        <meta
          property="og:description"
          content="Simplify your retail operations with myGINNE, Egypt’s smartest cashier & POS system. Works offline, supports Arabic, and sets up in 10 minutes. Free trial!"
        />
        <meta
          property="og:image"
          content="https://assets.myginne.com/assets/lahloob_prod/OG_Image.jpeg"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://store.myginne.com/" />

        {/* Meta Pixel Code */}
        <script>
          {`
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;
    s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window,document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '320514254388248');
    fbq('track', 'PageView');
  `}
        </script>

        <noscript
          dangerouslySetInnerHTML={{
            __html: `
      <img height="1" width="1"
      src="https://www.facebook.com/tr?id=320514254388248&ev=PageView&noscript=1"
      alt="fb pixel" />
    `
          }}
        />
        {/* End Meta Pixel Code */}


      </Helmet>
      <Header />
      <div className="pt-16">
        <HeroSection />
        <FeaturesSection />
        <TestimonialsSection />
        <OffersSection />
        <HowItWorksSection />
        <FinalCTASection />

        <footer className="bg-card border-t border-border py-6">
          <div className="container mx-auto px-4">
            <div className="grid md:[grid-template-columns:1.5fr_1fr_1fr_1fr] gap-8">
              <div className="space-y-1text-sm text-muted-foreground">
                <div className="flex items-center space-x-2 mb-3">
                  <Image
                    src={require("../../assets/Logo/hisabakLogo.png")}
                    alt="myGINNE logo"
                    width={130}
                  height={37}
                    preview={false}
                  />
                </div>
                <div
                  className={`text-[12px] mb-1 ${i18n.language === "ar" ? "text-right" : "text-left"
                    }`}
                  dir="ltr"
                >
                  {t("14 Prince Waleed Bin-Thinyan Al-Saud, Sheraton Al Matar, El Nozha, Cairo Governorate 11799")}
                </div>
              </div>
              <div>
                <h4 className="font-semibold mb-4 text-foreground">
                  {t("Contact Us")}
                </h4>
                <div
                  className={`flex items-center text-[12px] mb-1 ${i18n.language === "ar" ? "justify-end" : "justify-start"
                    }`}
                  dir="ltr"
                >
                  <PhoneCall
                    className={`${i18n.language === "ar" ? "mr-2" : "mr-2"
                      } w-4 h-4 text-primary`}
                  />
                  +20 104 021 1130
                </div>

                <div
                  className={`flex items-center text-[12px] mb-1 ${i18n.language === "ar" ? "justify-end" : "justify-start"
                    }`}
                  dir="ltr"
                >
                  <Mail
                    className={`${i18n.language === "ar" ? "mr-2" : "mr-2"
                      } w-4 h-4 text-primary`}
                  />
                  support@myginne.com
                </div>
              </div>
            </div>

            <div className="border-t border-border pt-6 mt-6 text-center text-muted-foreground">
              <p>
                {t(
                  "© 2025 myGINNE. All rights reserved. Made for Egyptian retailers with ❤️"
                )}
              </p>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default CashierLandingPage;
